"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUtilizeInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const UtilizeArgs_1 = require("../types/UtilizeArgs");
const UtilizeStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['utilizeArgs', UtilizeArgs_1.utilizeArgsBeet],
], 'UtilizeInstructionArgs');
const utilizeInstructionDiscriminator = 19;
function createUtilizeInstruction(accounts, args) {
    const { metadata, tokenAccount, mint, useAuthority, owner, useAuthorityRecord, burner } = accounts;
    const [data] = UtilizeStruct.serialize({
        instructionDiscriminator: utilizeInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: metadata,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: tokenAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: mint,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: useAuthority,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: owner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.ASSOCIATED_TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
    ];
    if (useAuthorityRecord != null) {
        keys.push({
            pubkey: useAuthorityRecord,
            isWritable: true,
            isSigner: false,
        });
    }
    if (burner != null) {
        if (useAuthorityRecord == null) {
            throw new Error("When providing 'burner' then 'useAuthorityRecord' need(s) to be provided as well.");
        }
        keys.push({
            pubkey: burner,
            isWritable: false,
            isSigner: false,
        });
    }
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s'),
        keys,
        data,
    });
    return ix;
}
exports.createUtilizeInstruction = createUtilizeInstruction;
//# sourceMappingURL=Utilize.js.map